import { useState } from "react"
import {
  HeroSection,
  IntegrationsList,
  CtaSection,
  allIntegrations,
} from "@/components/product/integrations"
import { FooterSection } from "@/components/home/footer"
import { usePageTitle } from "@/hooks/use-page-title"

/**
 * Integrations product page.
 * Showcases all supported integrations with search functionality.
 */
export function IntegrationsProductPage() {
  const [searchQuery, setSearchQuery] = useState("")

  const pageTitle = usePageTitle(
    "Integrations",
    `Connect your AI agents to ${allIntegrations.length}+ apps including Slack, Gmail, Salesforce, and more. Seamlessly integrate with the tools you already use.`
  )

  return (
    <div className="w-full">
      {pageTitle}
      <HeroSection
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        totalIntegrations={allIntegrations.length}
      />
      <IntegrationsList searchQuery={searchQuery} />
      <CtaSection />
      <FooterSection />
    </div>
  )
}

IntegrationsProductPage.displayName = "IntegrationsProductPage"
